import {
  Dialog,
  Box,
  Button,
  Typography,
  Card,
  CardActionArea
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import './SelectModeDialog.css';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppContext } from '../../application/App.Context';

interface Props {
  open?: boolean;
  title?: string;
  onClose: () => void;
  size?: any;
  setLeave: (e: boolean) => void
}

const SelectModeDialog: React.FC<Props> = ({
  open = true,
  title = '',
  onClose,
  size = 'xs',
  setLeave
}) => {
  const { t } = useTranslation();
  const { login, user, setRequestType} = useAppContext();

  const [selectedOption, setSelectedOption] = useState<'external' | 'internal' | null>(null);
  const handleConfirm = () => {
    if (selectedOption === 'internal'){
      setRequestType('internal');
      if (user?.valid){
        onClose()
        setLeave(true)
      } else {
        login();
      }
    } else if (selectedOption === 'external') {
      onClose()
      setLeave(true)
      setRequestType('external');
    }
  };

  useEffect(() => {
    setSelectedOption(null)
  }, [open]);


  return (
    <Dialog
      disableEnforceFocus
      className="SelectModeDialog-Container"
      open={open}
      onClose={onClose}
      maxWidth={size}
      fullWidth
      data-testid="selectModeDialog"
    >
      <Box className="SelectModeDialog-TitleBox">
        <Typography variant="h6" className="SelectModeDialog-Title">
          {title}
        </Typography>
        <Button className="SelectModeDialog-Close" onClick={onClose}>
          <CloseIcon fontSize="small" />
        </Button>
      </Box>
      <Box className="SelectModeDialog-ContentBox">
      <Box display="flex" flexDirection="column" gap={2}>
    <Card
            variant={selectedOption === 'external' ? 'outlined' : undefined}
            sx={{
              border: selectedOption === 'external' ? '2px solid #ccc' : '1px solid #ccc',
              backgroundColor: selectedOption === 'external' ? '#e3e1e1' : '#fff', 
              borderRadius: 2,
            }}
          >
            <CardActionArea onClick={() => setSelectedOption('external')} sx={{ padding: 2 }} id="selectOptionExternal" data-testid="selectOptionExternal">
              <Typography variant="subtitle1" fontWeight="bold">{t('externalModeTitle')}</Typography>
              <Typography variant="body2">{t('externalModeSubtitle')}</Typography>
            </CardActionArea>
          </Card>

          <Card
            variant={selectedOption === 'internal' ? 'outlined' : undefined}
            sx={{
              border: selectedOption === 'internal' ? '2px solid #ccc' : '1px solid #ccc',
              backgroundColor: selectedOption === 'internal' ? '#e3e1e1' : '#fff', 
              borderRadius: 2,
            }}
          >
            <CardActionArea onClick={() => setSelectedOption('internal')} sx={{ padding: 2 }} id="selectOptionInternal" data-testid="selectOptionInternal">
              <Typography variant="subtitle1" fontWeight="bold">{t('internalModeTitle')}</Typography>
              <Typography variant="body2">
              {t('internalModeSubtitle')}
              </Typography>
            </CardActionArea>
          </Card>
    </Box>
      </Box>
      <Box className="infoDialog-ButtonsBox">
        <Button
          autoFocus
          className={'infoDialog-Button infoDialog-Button-Default'}
          variant="contained"
          onClick={handleConfirm}
          disabled={!selectedOption}
          id='confirmButton'
          data-testid='confirmButton'
        >
          {t('confirm')}
        </Button>
      </Box>
    </Dialog>
  );
};

export default SelectModeDialog;
